import { render } from "./RouteComponent.vue?vue&type=template&id=5c4001a3&ts=true"
import script from "./RouteComponent.vue?vue&type=script&lang=ts"
export * from "./RouteComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__